import React, { createContext, useContext, useState } from "react";

interface IFabContext {
  showZendesk: boolean;
  setShowZendesk: (showZendesk: boolean) => void;
  showWatson: boolean;
  setShowWatson: (showWatson: boolean) => void;
  showVideo: boolean;
  setShowVideo: (showVideo: boolean) => void;
}

export const FabContext = createContext<any>({});

export const FabProvider: React.FC = ({ children }) => {
  const [showZendesk, setShowZendesk] = useState(false);
  const [showWatson, setShowWatson] = useState(true);
  const [showVideo, setShowVideo] = useState(true);

  return (
    <FabContext.Provider
      value={{
        showZendesk,
        setShowZendesk,
        showWatson,
        setShowWatson,
        showVideo,
        setShowVideo,
      }}
    >
      {children}
    </FabContext.Provider>
  );
};

export const useFab = (): IFabContext => useContext(FabContext);
